import type {ReactElement} from 'react';
import React from 'react';
import type {SliderOptionsContainerProps} from './slider-options-container.types';
import styles from './slider-options-container.module.scss';

export function SliderOptionsContainer({className = '', ...props}: SliderOptionsContainerProps): ReactElement {
  return (
    <div key={props.id} className={`${className} flex-v-row ${styles.container}`}>
      <div className={`flex-row-justify-between flex-items-center spacing-m-b-3 ${styles.upperContainer}`}>{props.upperContainer}</div>
      {props.slider}
    </div>
  );
}
